import { http } from '@frontend/fetch';
import {
  LocationDataSourcesRequest,
  LocationDataSourcesResponse,
  SyncAppAuthCheckData,
  SyncAppAuthCheckRequest,
  SyncAppAuthCheckResponse,
} from './types';

const SyncAppEndpoints = {
  authCheck: 'desktop/v1/syncapp/tool/check/',
  dataSources: 'syncapp/integrations-service/locations/:locationid/data-sources',
};
export const fetchSyncAppAuthCheck = async (request: SyncAppAuthCheckRequest): Promise<SyncAppAuthCheckData> => {
  const { data } = await http.get<SyncAppAuthCheckResponse>(SyncAppEndpoints.authCheck, {
    headers: {
      'Location-ID': request.locationId,
    },
  });

  return data;
};

export const fetchDataSources = async (request: LocationDataSourcesRequest): Promise<LocationDataSourcesResponse> => {
  const endpoint = SyncAppEndpoints.dataSources.replaceAll(':locationid', request.locationId);
  const res = await http.get<LocationDataSourcesResponse>(endpoint, {
    headers: {
      'Location-ID': request.locationId,
    },
  });

  return res;
};
